import { useMutation } from '@apollo/client'
import {
  AddInsuranceCompany,
  AddInsuranceCompanyVariables,
  AddInsuranceCompanyInput,
} from '../../types'
import { ADD_INSURANCE_COMPANY } from './operations'

interface AddInsuranceCompanyProps {
  onCompleted?: () => void
  filter?: AddInsuranceCompanyInput
}

export const useAddInsuranceCompany = ({ onCompleted }: AddInsuranceCompanyProps) =>
  useMutation<AddInsuranceCompany, AddInsuranceCompanyVariables>(ADD_INSURANCE_COMPANY, {
    onCompleted,
  })
